(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enter-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var gate = document.querySelector('[data-enter-gate]');
    if (!gate) return;

    var SLEUTEL = 'noveraux:entered';
    var onthoud = gate.getAttribute('data-remember') === 'true';

    // Opslag kan gooien (privémodus, geblokkeerde site-data). Dan tonen we de deur gewoon.
    function alBinnen() {
      if (!onthoud) return false;
      try { return sessionStorage.getItem(SLEUTEL) === '1'; } catch (e) { return false; }
    }
    function noteer() {
      if (!onthoud) return;
      try { sessionStorage.setItem(SLEUTEL, '1'); } catch (e) {}
    }

    // In de theme-editor moet de sectie altijd zichtbaar zijn, anders kan de operator
    // hem niet bewerken — daar telt het onthouden dus niet.
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    if (alBinnen() && !inEditor) return;

    var body = document.body;
    var scrollWasOp = body.style.overflow;

    /*
      DE BRON WORDT HIER GEKOZEN, bij het laden — niet bij het klikken.
      Stond dit eerst in de openfunctie, met als gevolg dat de video tot de klik
      helemaal geen bron had: je zag alleen de liggende poster, in de verkeerde uitsnede.

      Een liggende film schermvullend maken op een staand scherm kan niet scherp: van een
      16:9-beeld zie je op een telefoon nog maar 26% van de breedte, en die strook wordt
      3,4x opgerekt. Vandaar een aparte staande versie. Er wordt er altijd maar één opgehaald.
    */
    var filmEl = gate.querySelector('[data-enter-gate-film]');
    if (filmEl) {
      var staand = window.matchMedia('(max-aspect-ratio: 3/4)').matches
                && filmEl.getAttribute('data-film-staand');
      if (staand) {
        var ps = filmEl.getAttribute('data-poster-staand');
        if (ps) filmEl.poster = ps;
        var rs = filmEl.getAttribute('data-ratio-staand');
        gate.style.setProperty('--enter-gate-ratio', rs);
        /*
          De scene draagt de verhouding als INLINE stijl uit Liquid (die van de liggende
          achtergrondfoto). Een inline waarde op het kind wint van de geerfde waarde op
          de gate, dus zonder deze regel bleef de scene 16:9 en werd de staande film met
          object-fit:fill in een liggende doos van 1455x812 uitgerekt: reuzenjassen.
        */
        var sceneEl = gate.querySelector('.enter-gate__scene');
        if (sceneEl) sceneEl.style.setProperty('--enter-gate-ratio', rs);
        gate.style.setProperty('--enter-gate-focus',
          (parseFloat(filmEl.getAttribute('data-focus-staand')) / 100) || 0.4);
      }
      filmEl.src = staand ? filmEl.getAttribute('data-film-staand')
                          : filmEl.getAttribute('data-film-liggend');
    }

    gate.removeAttribute('hidden');
    body.style.overflow = 'hidden';

    var knop = gate.querySelector('[data-enter-gate-button]');
    if (knop) {
      // Markeren zodat de focusrand niet als kader om het woord verschijnt; zodra de
      // bezoeker zelf het toetsenbord gebruikt halen we de markering weg en komt de
      // rand terug waar hij hoort.
      knop.setAttribute('data-autofocused', '');
      try { knop.focus({ preventScroll: true }); } catch (e) { knop.focus(); }
      window.addEventListener('keydown', function () {
        knop.removeAttribute('data-autofocused');
      }, { once: true });
    }

    var bezig = false;
    function open() {
      if (bezig) return;
      bezig = true;
      noteer();
      body.style.overflow = scrollWasOp;
      // De stroken krijgen hun eindstand rechtstreeks; de overgang staat al in de CSS.
      // Met een film speelt de film; de stroken blijven dan ongebruikt.
      var film = gate.querySelector('[data-enter-gate-film]');
      if (film) {
        // Versneld afspelen en er halverwege uitstappen: de clip duurt 8 seconden, en zo
        // lang laat je niemand voor een dichte deur staan. Bij 2x en uitstappen op 60%
        // duurt de doorgang ongeveer 2,4 seconde — precies tot de jassen opzij zijn.
        film.playbackRate = 2;
        var stoppen = function () {
          if (film.duration && film.currentTime >= film.duration * 0.6) {
            film.pause();
            gate.classList.add('enter-gate--doorgang');
            film.removeEventListener('timeupdate', stoppen);
          }
        };
        film.addEventListener('timeupdate', stoppen);
        var spelen = film.play();
        if (spelen && spelen.catch) spelen.catch(function () {
          // Autoplay geweigerd: dan gewoon direct door, zonder film.
          gate.classList.add('enter-gate--doorgang');
        });
      }

      // Let op de naam: `weg` is verderop de opruimfunctie. Twee keer `var weg` in
      // dezelfde functie is één variabele — vandaar `afstand` hier.
      var stroken = gate.querySelectorAll('.enter-gate__strip');
      for (var i = 0; i < stroken.length; i++) {
        var afstand = getComputedStyle(stroken[i]).getPropertyValue('--strip-weg') || '0%';
        stroken[i].style.transform = 'translate3d(' + afstand.trim() + ', 0, 0)';
      }
      gate.classList.add('enter-gate--leaving');
      var weg = function () { if (gate.parentNode) gate.parentNode.removeChild(gate); };
      // Vangnet: als de overgang niet vuurt (reduced motion, tab op de achtergrond)
      // moet de deur alsnog verdwijnen.
      // Alleen op de animatie die als LAATSTE eindigt. Zonder deze controle vuurt
      // animationend al na 220ms — het wegvallen van de tekst — en wordt de deur
      // weggehaald terwijl de jassen nog aan het openschuiven zijn.
      var laatste = { 'enter-gate-doorgang': 1, 'enter-gate-through': 1 };
      gate.addEventListener('animationend', function (e) {
        if (laatste[e.animationName]) weg();
      });
      // Alleen de vervaging van het scherm zelf telt. transitionend borrelt op vanuit
      // de kinderen, en het streepje onder ENTER heeft een overgang van 320ms — zonder
      // deze controle wordt de deur daardoor weggehaald terwijl de kleding nog schuift.
      gate.addEventListener('transitionend', function (e) {
        if (e.target === gate && e.propertyName === 'opacity') weg();
      });
      setTimeout(weg, film ? 4000 : 1600);
    }

    if (knop) knop.addEventListener('click', open);
    gate.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') open();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
